import {useState} from "react";
import {isFloatNumber, isNumber} from "../helpers/validationHelper";
import {parseFloatSafe} from "../helpers/helperFunctions";

const useInput = (defaultValue, isCheckBox = false) => {
  const [value, setValue] = useState(defaultValue ?? (isCheckBox ? false : ""));

  // const onChange = (e) => {
  //   setValue(e.target.value);
  //   console.log(e.target.value)
  //   }
  const onChange = (e) => {
    setValue(isCheckBox ? e.target.checked : e.target.value);
  };

  return {value, setValue, onChange};

};

export default useInput;

export const useInputWithMaxLength = (defaultValue = "", maxLength = 1000) => {
  const [value, setValue] = useState(defaultValue);

  const onChange = (e) => {
    const val = e.target.value;
    // if (val.length <= maxLength) {
    setValue(val);
    // }
  };

  return {value, setValue, onChange};
};

export const useNumberWithMaxAndMin = (defaultValue = "", isFloat = false, max = 1000, min=0) => {
  const [value, setValue] = useState(defaultValue);

  const onChange = (e) => {
    const val = e.target.value;
    const num = parseFloatSafe(val);
    if (!num || (num <= max && num>=min)) {
      setValue((isFloat ? isFloatNumber(val, true) : isNumber(val, true)) ? val : value);
    }
  };

  return {value, setValue, onChange};
};


export const useNumberWithMaxLength = (defaultValue, maxLength = 1000) => {
  const [value, setValue] = useState(defaultValue)

  const onChange = (e) => {
    const val = e.target.value
    if (val.length <= maxLength) {
          setValue(isNumber(val, true) ? val : value)
    }
  }

  return {value, setValue, onChange}
}
